<template>
  <div>
    <vs-table :data="tutor" :pagination="tutor.length >= elements_per_page" >
      <template slot="thead">
        <vs-th :key="i" v-for="(e, i) in ['Nome', 'Cognome', 'Email', 'Max tirocini', 'Assegnati', 'Azioni']">{{e}}</vs-th>
      </template>
      <template slot-scope="{data}">
        <vs-tr class="shadow" :key="tr.id" v-for="tr in data" :state="tr.stato_modulo == 1 ? 'danger' : null">

          <vs-td>
            {{ tr.name }}
          </vs-td>

          <vs-td>
            {{ tr.surname }}
          </vs-td>

          <vs-td>
            {{ tr.email }}
          </vs-td>

          <vs-td>
            {{ tr.max_tirocini }}
          </vs-td>

          <vs-td>
            {{tr.tirocini.length}}
            <!-- {{ tr.tirocini.filter( t => {
              if (t.stato != 'cancelled' && t.stato != 'stop' && t.stato != 'complete')
              return t
            }).length }} -->
          </vs-td>

          <vs-td>
            <vx-tooltip text="Visualizza">
              <vs-button @click="modificaTutor(tr)" class="inline-block ml-2" radius color="primary" size="small" type="line" icon-pack="feather" icon="icon-eye"></vs-button>
            </vx-tooltip>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <vs-sidebar click-not-close position-right parent="body" color="primary" class="sidebarx sidebarpage sidebar-pacchetti" spacer :value="!!selected">
      <TutorForm @close-me="sidebarClose" :selected="selected" v-if="selected" @saved="$parent.refreshTutor()"/>
    </vs-sidebar>
  </div>
</template>

<script>
import ExpandTutor from './ExpandTutor.vue'
import TutorForm from './TutorForm.vue'

export default {
  components: {
    TutorForm,
    ExpandTutor,
  },

  props: {
    tutor: {
      type: Array,
      required: true,
    },
  },

  data () {
    return {
      selected: null,
      readonly: false,
      self: this,
      cambia_stato: null,
      sidebar_active: false,
      elements_per_page: 15,
    }
  },

  computed: {
    cambia_stato_open: {
      get () { return !!this.cambia_stato },
      set (v) { if (!v) this.cambia_stato = null }
    },
  },

  methods: {
    // checkTirociniAttivi(tir_list) {
    //   console.log('THIS => ',tir_list.filter( t => {
    //     console.log(t);
    //     // if (new Date() < new Date(t.data_fine)) return t
    //     if (t.stato != 'stop' && t.stato != 'cancelled') return t
    //   }).length);
    //   return tir_list.filter( t => {
    //     let verify = (t.stato != 'stop' && t.stato != 'cancelled' && t.stato != 'complete') && (new Date() < new Date(t.data_fine))
    //     // console.log(t);
    //     if (verify) return t
    //   }).length
    // },
    mostraTutor(t) {
      this.readonly = true
      this.selected = t
    },
    modificaTutor(t) {
      this.readonly = false
      this.selected = t
    },
    cambiaStato(t) {
      this.cambia_stato = t
    },
    sidebarClose() {
      this.selected = null
      this.sidebar_active = false
    }
  },
}
</script>

<style lang="scss">
.tabella-tutor {
  .horizontal-timeline {
    align-items: flex-start;
  }
  .timeline-item {
    flex-grow: 1;
  }
  .horizontal-timeline .status {
    text-align: center;
    padding: 15px 10px;
  }

}
.sidebar-dettagliotutor {
  .vs-sidebar {
    max-width: 80rem;
  }
}
.sidebar-tutorcambiastato {
  .vs-sidebar {
    max-width: 40rem;
  }
}
.spaced-buttons {
  .con-vs-tooltip {
    margin-left: 10px;
  }
}
</style>
